import { FixedColumnSlider } from '../core/fixed-column-slider';

export const CollectionSlider = FixedColumnSlider;
